import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { SouscriptionApiType } from "@/api/souscriptionApi";
import Popin from "@/components/Popin";
import PdfViewVer from "@/components/PdvViewver";
import { downloadFileFromLink } from "@/utils";
import devisApi from "@/api/devisApi";
import IconButton from "@material-ui/core/IconButton";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";

const AfficheDevis = ({
  souscription,
}: {
  souscription: SouscriptionApiType;
}) => {
  const { t } = useTranslation();

  const [urlPDF, setUrlPDF] = useState<string | null>(null);
  const [erreurGenerationPDF, setErreurGenerationPDF] = useState(false);
  const [affichePopinDevis, setAffichePopinDevis] = useState(false);

  const nomComplet =
    souscription.prenom && souscription.nom
      ? "_" + souscription.prenom + "_" + souscription.nom
      : "";

  useEffect(() => {
    if (
      souscription.uuid &&
      affichePopinDevis &&
      !urlPDF &&
      !erreurGenerationPDF
    ) {
      generarerPdf();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [affichePopinDevis]);

  const generarerPdf = async () => {
    try {
      const blob = await devisApi.genererDevisC2({
        parcoursUUID: souscription.uuid!,
      });
      setUrlPDF(URL.createObjectURL(new Blob([blob])));
    } catch (error) {
      setUrlPDF(null);
      setErreurGenerationPDF(true);
    }
  };

  const telechargerDevis = () => {
    if (urlPDF) {
      downloadFileFromLink(urlPDF, "Devis_PNO" + nomComplet, "pdf");
    }
  };

  const isDevisAbsent = !souscription.numDevis;

  return (
    <>
      <IconButton
        style={{ color: isDevisAbsent ? "grey" : "red" }}
        disabled={isDevisAbsent}
      >
        <PictureAsPdfIcon onClick={() => setAffichePopinDevis(true)} />
      </IconButton>
      <Popin
        title={t("pno.recapitulatif.visualiserDevis")}
        content={<PdfViewVer filePath={urlPDF} error={erreurGenerationPDF} />}
        open={affichePopinDevis}
        maxWidth="lg"
        onClose={() => {
          setErreurGenerationPDF(false);
          setAffichePopinDevis(false);
        }}
        showCancelButton={true}
        cancelButtonLabel={t("common.popin.btn_close")}
        isValidateButtonDisabled={!urlPDF || erreurGenerationPDF}
        onValidate={telechargerDevis}
        validateButtonLabel={t("common.download")}
      />
    </>
  );
};
export default AfficheDevis;
